import MarkdownP from './component.jsx'
export default MarkdownP
